export * from "ce/api/TenantApi";
import { TenantApi as CE_TenantApi } from "ce/api/TenantApi";

class TenantApi extends CE_TenantApi {}

export default TenantApi;
